import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';
import sellers from '../../design-system/Assets/sellers_bg.png';

export const Jumbo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-left: 16px;
  padding-right: 16px;
  ${'' /* background: #fafafa; */}
  padding-top: 10px;
  padding-bottom: 30px;
  background-image: url(${sellers});
  background-size: contain; /* Adjust as needed */
  background-repeat: no-repeat;

  ${mediaQuery.desktop`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 30px;
  background-image: url(${sellers});
 background-size: contain; /* Adjust as needed */
  background-repeat: no-repeat;
  height: 161px; 
  background-position: right;
  `}

  .sellers_name {
    color: #333333;
    margin: 0;
    font-size: 20px;
    font-weight: 700;
  }

  .short_bio {
    margin-top: 10px;
    margin: 0;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }

  .delivery_location {
    margin: 0;
    margin-top: 25px;
    font-size: 24px;
    font-weight: 700;
    color: #333333;
  }

  img {
    width: 345px;
    height: 345px;
    border-radius: 100%;
    object-fit: cover;
  }
`;

export const Body = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  background: #fff;
  padding-top: 10px;
  padding-bottom: 24px;

  ${mediaQuery.desktop`
  padding-left: 40px;
  padding-right: 40px;
  background: #fff;
  padding-top: 24px;
  padding-bottom: 24px;
  `}
  .cards {
    display: grid;
    gap: 21px;
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQuery.desktop`
  .cards {
    display: grid;
    gap: 32px;
    grid-template-columns: repeat(3, 1fr);
  }
  `}

  .card {
    flex: 0 0 200px;
    width: auto;
    height: auto;
    padding-bottom: 0;
  }
  .card img {
    width: 100%;
    height: 177px;
    border-radius: 2px;
    object-fit: center;
  }

  .skeleton_img {
    max-width: auto;
    height: 177px;
    border-radius: 2px;
    object-fit: cover;
  }

  ${mediaQuery.desktop`
  .card img {
    width: 100%;
    height: 304px;
    object-fit: cover;
  }

  .skeleton_img {
    width: 100%;
    height: 304px;
    object-fit: cover;
  }
  `}

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .badge {
    display: grid;
    place-items: center;
    background: #ffd6d6;
    height: 23px;
    color: #eb5757;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 2px;
  }

  ${mediaQuery.desktop`
  .card-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  `}

  .card_title {
    font-style: normal;
    font-weight: 500;
    color: #333333;
    font-size: 16px;
    line-height: 25px;
    textoverflow: ellipsis;
  }

  ${mediaQuery.desktop`
  .card_title {
    font-style: normal;
    font-weight: 500;
    color: #333333;
    font-size: 18px;
    line-height: 25px;
    textOverflow: ellipsis;
  }
  `}

  .card_sellers_name {
    margin: 0;
    white-space: nowrap;
    color: #4f4f4f;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 1px;
  }

  ${mediaQuery.desktop`
  .card_sellers_name {
    margin: 0;
    white-space: nowrap;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    margin-bottom:8px;
  }

  `}

  ${mediaQuery.desktop`
  .card_title {
    font-style: normal;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 25px;
  }
  `}

  .delivery_location {
    margin: 0;
    margin-bottom: 10px;
    color: #333333;
    font-size: 14px;
    font-weight: 700;
  }

  ${mediaQuery.desktop`
  .delivery_location {
    margin: 0;
    margin-bottom: 8px;
    color: #333333;
    font-size: 24px;
    font-weight: 700;
  }
  `}

  .product_title {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 10px;
  }

  ${mediaQuery.desktop`
  .product_title {
    color: #000000;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 22px;
  }
  
  `}

  .card_price {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    white-space: nowrap;
    line-height: 28px;
  }

  ${mediaQuery.desktop`
  .card_price{
    margin: 0;
    font-size: 20px;
    font-weight:400;
    color: #000000;
    white-space: nowrap;
    line-height: 28px;
  }
  
  `}
`;

export const DeliveryLocationList = styled.li`
  background-color: #edfafa;
  display: inline-block;
  padding: 4px;
  box-sizing: border-box;
  color: #549a9a;
  width: auto;
  font-size: 14px;
  font-weight: 500;
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background: #003232;
    color: #fff;
  }

  ${mediaQuery.desktop`
  background-color: #edfafa;
  display: inline-block;
  padding: 4px;
  border-radius: 2px;
  box-sizing: border-box;
  font-family: Poppins;
  color: #549a9a;
  width: auto;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #003232;
    color: #fff;
  }
  `}
`;

export const DeliveryLocation = styled.ul`
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  gap: 8px;
  margin-bottom: 29px;

  ${mediaQuery.desktop`
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  gap: 8px;
  margin-bottom:50px;
  `}
`;

export const SearchBox = styled.div`
  display: flex;
  gap: 13px;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 45px;

  .input_box {
    display: flex;
    width: 100%;
    align-items: center;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;

    input {
      border: none;
      font-size: 16px;
      width: 100%;
      padding: 13px;
      align-self: stretch;
      box-sizing: border-box;

      &:placeholder {
        color: #e0e0e0;
        font-sizie: 14px;
        font-weight: 400;
      }
    }
  }
`;

export const DropDownMenu = styled.div`
  position: relative;
  display: inline-block;

  .dropdown_toggle {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 13px 25px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    background: #fff;
    cursor: pointer;
    white-space: nowrap;
    gap: 0px;
  }

  .text {
    display: none;
  }

  ${mediaQuery.desktop`
    .text {
      display: block;
    }

     .dropdown_toggle {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 13px 25px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    background: #fff;
    cursor: pointer;
    white-space: nowrap;
    gap: 10px;
  }

  `}

  .dropdown_content {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    ${'' /* min-width: 160px; */}
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    margin-top: 10px;
    height: auto;
    overflow-y: scroll;
    border-radius: 5px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .category {
    padding: 10px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;

    &:hover {
      background: #edfafa;
      color: #549a9a;
    }
  }
`;

export const ProductBody = styled.div`
  display: grid;
  grid-template-columns: auto;
  gap: 24px;
  margin-top: 80px;

  .left_side {
    display: flex;
    flex-direction: row;
    gap: 18px;
  }

  .filter_btn {
    display: block;
    border-radius: 8px;
    background: #549a9a;
    display: grid;
    place-items: center;
    width: 45px;
    padding: 10px;
    cursor: pointer;
  }

  ${mediaQuery.desktop`
  display: grid;
  grid-template-columns: 241px auto;
  gap: 56px;
  margin-top: 80px;
  
  .left_side {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .filter_btn {
    display: none;
  }
  
  `}
`;
